/**
 * Created by netre on 27.06.2017.
 */
import React from 'react';

export const MapTooltip = (props) => {
  const {text, type} = props;
    return (<div className={`car-note start-note`} style={{display:'block', zIndex:'9999', position:'absolute',bottom:'20px', top:'auto'}}>
        <span>{text}</span>
      </div>
      )
};



// WEBPACK FOOTER //
// ./src/components/DeviceControl/Tooltip.js